import { RenderNode } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

export const renderAllTextAsSpans: RenderNode = {
  [BLOCKS.HEADING_1]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_2]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_3]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_4]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_5]: (_, children) => <span>{children}</span>,
  [BLOCKS.HEADING_6]: (_, children) => <span>{children}</span>,
  [BLOCKS.PARAGRAPH]: (_, children) => <span>{children}</span>,
};
